require('./style.css');
let tmpl = require('./main.ejs');
let Events = require('f.core.event');

let padding = function(val) {
    if (val < 10) {
        return '0' + val;
    }
    return val;
};

let Cutdown = function(time) {
    this.time = time;
    this.remainTime = Math.floor((new Date(time).valueOf() - new Date().valueOf()) / 1000);
    console.log('remainTime=====>' + this.remainTime);
    this.timer = null;
    this.init();
};

Cutdown.prototype.init = function() {
    this.initDom();
    this.initEvent();
};

Cutdown.prototype.initDom = function() {
    let div = document.createElement('div');
    div.innerHTML = tmpl({ title: this.title });
    this.el = div.children[0];
    this.elTime = this.el.querySelector('.c-count-down__time');
};

Cutdown.prototype.begin = function() {
    if (this.remainTime <= 0) {
        this.trigger('end');
        this.hide();
        clearInterval(this.timer);
    }
    this.renderTime();
    this.timer = setInterval(
        function() {
            this.remainTime--;
            this.renderTime();
            if (this.remainTime <= 0) {
                this.trigger('end');
                this.hide();
                clearInterval(this.timer);
            }
        }.bind(this),
        1000
    );
};

Cutdown.prototype.renderTime = function() {
    let remain = this.remainTime;
    let day = Math.floor(remain / (60 * 60 * 24));
    remain = remain - day * 60 * 60 * 24;
    let hour = Math.floor(remain / (60 * 60));
    remain = remain - hour * 60 * 60;
    let minute = Math.floor(remain / 60);
    let second = remain - minute * 60;
    this.elTime.innerHTML = padding(day) + ':' + padding(hour) + ':' + padding(minute) + ':' + padding(second);
};

Cutdown.prototype.initEvent = function() {};

Cutdown.prototype.hide = function() {
    this.el.style.display = 'none';
};

Cutdown.prototype.show = function() {
    this.el.style.display = 'flex';
};

Cutdown.prototype.renderTo = function(parentNode) {
    parentNode.appendChild(this.el);
};

Cutdown.prototype.destory = function() {
    this.off();
    clearInterval(this.timer);
    this.el.parentNode.removeChild(this.el);
};

Events.mixTo(Cutdown);

module.exports = Cutdown;



// WEBPACK FOOTER //
// /Users/gebb/Desktop/live/modules/f.compenont.video.mobile/app/modules/cutdown/index.js